import {
  GridContainer,
  GridItem,
  CheckboxFormField,
  FormSection,
  ApplicationType,
  ApplicationSubtype,
} from "@duosoftbg/nacid-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormLabel } from "@mui/material";
import ServiceTypeFormFields from "../../../../common/form/education/parts/ServiceTypeFormFields";

const ApplicationDetailsFormSection = ({ isSubmittedOrFinalized }) => {
  const { t } = useTranslation();

  return (
    <FormSection label={"t.uniChecks.application.details"}>
      <GridContainer>
        <GridItem sm={12} md={12}>
          <FormLabel required={true}>{t("l.serviceKind")}</FormLabel>
        </GridItem>
        <GridItem sm={4} md={3}>
          <CheckboxFormField fieldName={"statute"} labelCode={"l.statute"} isDisabled={isSubmittedOrFinalized} />
        </GridItem>
        <GridItem sm={4} md={3}>
          <CheckboxFormField
            fieldName={"authenticity"}
            labelCode={"l.authenticity"}
            isDisabled={isSubmittedOrFinalized}
          />
        </GridItem>
        <GridItem sm={4} md={3}>
          <CheckboxFormField
            fieldName={"recommendation"}
            labelCode={"l.recommendation"}
            isDisabled={isSubmittedOrFinalized}
          />
        </GridItem>
      </GridContainer>
      <ServiceTypeFormFields
        applicationType={ApplicationType.ACADEMIC_RECOGNITION}
        applicationSubtype={ApplicationSubtype.UNI_CHECKS}
        isDisabled={isSubmittedOrFinalized}
      />
    </FormSection>
  );
};
export default ApplicationDetailsFormSection;
